/******************************************************************************
 * Copyright (c) 2016 - 2021.                                                 *
 * Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)          *
 * All Rights Reserved.                                                       *
 *                                                                            *
 * The software and data contained herein are confidential and proprietary    *
 * information of Yega Yazilim ("Confidential Information").                  *
 *                                                                            *
 * Users of this software may not disclose such Confidential Information and  *
 * shall use it only in accordance with the terms of the license agreement    *
 * they entered into with Yega Yazilim.                                       *
 *                                                                            *
 * Author:  Ahmet Dogramaci                                                   *
 * Date:    2021-03-03                                                        *
 ******************************************************************************/

import no_spinner_axios from '../../utils/no-spinner-axios';

let cachedUser = null;
let cachedUserPromise = null;

const CurrentUserStore = {
    namespaced: true,
    state: {
        user:{}
    },
    mutations: {
        storeUser(state,userObject){
            state.user = userObject;
        }
    },
    actions: {
        show_cached(context){
            if(cachedUser){
                context.commit('storeUser', cachedUser);
                return Promise.resolve(cachedUser);
            }
            if(cachedUserPromise){
                return cachedUserPromise;
            }
            cachedUserPromise = context.dispatch('show')
                .then((user)=>{
                    cachedUser = user;
                    return user;
                })
                .catch((error)=>{
                    cachedUserPromise = null;
                    throw error;
                });
            return cachedUserPromise;
        },
        show(context,params={}){
            return new Promise(callAxios);

            function callAxios(resolve, reject) {
                no_spinner_axios
                    .get('/v2/current_user', {
                        params: params
                    })
                    .then(success)
                    .catch(failure);

                function success(response) {
                    if(Object.keys(params || {}).length === 0){
                        cachedUser = response.data;
                    }
                    resolve(response.data);
                    context.commit('storeUser',response.data);
                }
                function failure(error) {
                    console.log(error);
                    reject(error);
                }
            }
        }
    }
};
export default CurrentUserStore;
